<button
  [type]="type"
  [class]="buttonClass"
  [disabled]="disabled || loading"
  [attr.aria-label]="ariaLabel || null"
  [attr.aria-busy]="loading || null"
  (click)="onClick($event)">

  <!-- Loading spinner -->
  @if (loading) {
    <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
  }

  <!-- Left icon -->
  @if (leftIcon && !loading) {
    <lucide-icon
      [name]="leftIcon"
      class="hc-btn-icon"
      aria-hidden="true">
    </lucide-icon>
  }

  <!-- Button content (hidden during loading for icon-only) -->
  @if (!iconOnly || !loading) {
    <ng-content></ng-content>
  }

  <!-- Right icon -->
  @if (rightIcon && !loading) {
    <lucide-icon
      [name]="rightIcon"
      class="hc-btn-icon"
      aria-hidden="true">
    </lucide-icon>
  }
</button>
